import * as React from 'react';
import {useTranslation} from "react-i18next";

interface IProps {
	category: string;
}

const TopPageTitle = ({category}: IProps) => {
	const {t} = useTranslation();

	if (category === "videos") return (
		<h2 className="title font-size-2-half text-align-center">
			{t("Exklusive")} <br/>
			{t("Videos deiner Lieblingsmodels")}
		</h2>
	)

	if (category === "livecams") return (
		<h2 className="title font-size-2-half text-align-center">
			{t("Erlebe")} <br/>
			{t("Live-Cams mit deinen Models")}
		</h2>
	)

	if (category === "chatting") return (
		<h2 className="title font-size-2-half text-align-center">
			{t("Chatte")} <br/>
			{t("privat mit deinen Models")}
		</h2>
	)

	return null;
};

export default TopPageTitle
